module.exports = __webpack_public_path__ + "img/listattendancestudent.f555f199.svg";